// Angular
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';

// Rxjs
import { Observable, throwError } from 'rxjs';

// Services
import { ApiService } from '../api/api.service';

// Models
import { ProductOpinion, ProductOpinionRate } from '../../models/b2b/productOpinion';
import { map } from 'rxjs/operators';

@Injectable()
export class SoledadOpinionsService {
    constructor(private api: ApiService) {}

    getToken(): Observable<any> {
        // TODO @dani qué tipo de observable? $Dani

        const url = 'https://soledadopinions.servidorbeta.com/api/token';

        let param: HttpParams = new HttpParams();

        param = param.set('email', 'b2b@opinions.net');

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'text/plain',
            }),
        };

        return this.api.post(url, param.toString(), options).pipe(
            map(
                (data) => {
                    if (data.result !== 0 || !data.value || data.value.length === 0 || data.value[0].ERROR) {
                        throwError('Error to obtain promo data');
                    }
                    return data;
                },
                (error) => console.log('couldnt get to Soledad opinions')
            )
        );
    }

    getOpinions(productList: ProductOpinion[], market: string): Observable<ProductOpinionRate[]> {
        const url = 'https://soledadopinions.servidorbeta.com/api/opinions';

        const token = localStorage.getItem('tokenOpinions');

        const productsOpinions = {
            web: 'b2b',
            id_market_iso: market,
            items: productList,
        };

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                Accept: 'application/json, text/javascript, */*',
                'X-Authorization-Token': token,
            }),
        };

        return this.api.post(url, JSON.stringify(productsOpinions), options).pipe(
            map(
                (data) => {
                    // console.log('getOpinions', {data});

                    if (data || data.length === 0 || data.ERROR) {
                        throwError('Error to obtain getOpinions');
                    }

                    return data;
                },
                (error) => console.log('Couldnt get Soledad Opinions')
            )
        );
    }

    getOpinionDetail(product: ProductOpinion, market: string): Observable<any> {
        const url = 'https://soledadopinions.servidorbeta.com/api/opinions/get';

        const token = localStorage.getItem('tokenOpinions');

        const productsOpinions = {
            web: 'b2b',
            id_market_iso: market,
            ...product,
        };

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                Accept: 'application/json, text/javascript, */*',
                'X-Authorization-Token': token,
            }),
        };

        return this.api.post(url, JSON.stringify(productsOpinions), options).pipe(
            map(
                (data) => {
                    // console.log('getOpinionsDetail', data);

                    if (data || data.length === 0 || data.ERROR || !data.success) {
                        throwError('Error to obtain getOpinions');
                    }

                    if (data.data.product) {
                        data.data.product.avg.confort = Math.ceil(data.data.product.avg.confort);
                        data.data.product.avg.agarre_mojado = Math.ceil(data.data.product.avg.agarre_mojado);
                        data.data.product.avg.agarre_seco = Math.ceil(data.data.product.avg.agarre_seco);
                        data.data.product.avg.consumo = Math.ceil(data.data.product.avg.consumo);
                        data.data.product.avg.estabilidad = Math.ceil(data.data.product.avg.estabilidad);
                        data.data.product.avg.relation = Math.ceil(data.data.product.avg.relation);
                        data.data.product.avg.ruido = Math.ceil(data.data.product.avg.ruido);
                    }

                    return data;
                },
                (error) => console.log('Couldnt get Soledad Opinions Detail')
            )
        );
    }

    setNewOpinion(newOpinion: any): Observable<any> {
        console.log({ newOpinion });

        const url = 'https://soledadopinions.servidorbeta.com/api/opinions/new';

        const token = localStorage.getItem('tokenOpinions');

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                Accept: 'application/json, text/javascript, */*',
                'X-Authorization-Token': token,
            }),
        };

        return this.api.post(url, JSON.stringify(newOpinion), options).pipe(
            map(
                (data) => {
                    console.log('setNewOpinion', data);

                    // if (data || data.length === 0 || data.ERROR || !data.success) {
                    //     throwError ('Error to obtain getOpinions');
                    // }

                    return data;
                },
                (error) => console.log('Couldnt set new Opinion')
            )
        );
    }
}
